import { render, staticRenderFns } from "./min-max.vue?vue&type=template&id=6056cea6&scoped=true"
import script from "./min-max.vue?vue&type=script&lang=js"
export * from "./min-max.vue?vue&type=script&lang=js"
import style0 from "./min-max.vue?vue&type=style&index=0&id=6056cea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6056cea6",
  null
  
)

export default component.exports